import React, { useContext } from 'react';
import { CustomInput } from 'components';
import { useAppDispatch, useAppSelector } from 'hooks';
import { CreateEditEstimateNavEnum, CreateEstimateErrorTypes } from 'containers/estimates/constants';
import { CreateEstimateContextType } from 'containers/estimates/types';
import {
  removeEstimateValidationErrors,
  selectEstimateTitle,
  selectEstimateValidationErrors,
  updateEstimateTitle
} from 'containers/estimates/estimatesSlice';
import { getBorderStyles, getEstimateValidationErrors } from 'containers/estimates/utils';
import EstimateExpiry from './EstimateExpiry';
import AssignEstimatesMembers from 'containers/estimates/components/AssignEstimatesMembers';

interface CreateEstimateDetailsProps {
  context: React.Context<CreateEstimateContextType>;
}

const CreateEstimateDetails: React.FC<CreateEstimateDetailsProps> = ({ context }) => {
  const { selectedEstimateTab, setSelectedEstimateTab } = useContext<CreateEstimateContextType>(context);

  const dispatch = useAppDispatch();

  const selectedEstimateTitle = useAppSelector(selectEstimateTitle);
  const selectedEstimateValidations = useAppSelector(selectEstimateValidationErrors);
  const estimateTitleError = getEstimateValidationErrors(
    selectedEstimateValidations,
    CreateEstimateErrorTypes.ESTIMATE_TITLE
  );

  const isTabSelected = selectedEstimateTab === CreateEditEstimateNavEnum.ESTIMATE_DETAILS;
  const hasError = Boolean(estimateTitleError);

  const onEstimateTitleChange = (value: string) => {
    dispatch(updateEstimateTitle(value));
    dispatch(removeEstimateValidationErrors(CreateEstimateErrorTypes.ESTIMATE_TITLE));
  };

  // const onEstimateDescriptionChange = (value: string) => {
  //   dispatch(updateEstimateDescription(value));
  // };

  const onFocus = () => {
    setSelectedEstimateTab(CreateEditEstimateNavEnum.ESTIMATE_DETAILS);
  };

  const borderStyle = getBorderStyles({
    isSelected: isTabSelected,
    hasError
  });

  return (
    <div onFocus={onFocus}>
      <div className={`mb-2 text-xl font-bold ${isTabSelected ? 'text-primaryBtn' : 'text-heading'}`}>
        Estimate details
      </div>
      <div className={`flex flex-col gap-6 rounded-md border ${borderStyle} z-10 px-8 py-6`}>
        <div>
          <div className="mb-2 text-17px font-semibold">Estimate title</div>
          {estimateTitleError ? (
            <div className="mb-2 text-sbase font-semibold text-error">{estimateTitleError}</div>
          ) : null}
          <div>
            <CustomInput
              id="create-estimate-title"
              onChange={onEstimateTitleChange}
              placeholder="Enter estimate title"
              value={selectedEstimateTitle}
              className="px-5 text-[17px] font-normal leading-5 outline-none placeholder:text-[17px]"
              maxLength={50}
              showRemainingChar={true}
            />
          </div>
        </div>
        <AssignEstimatesMembers />
        <EstimateExpiry />
        {/* <div>
          <div className="mb-2 text-17px font-semibold text-headingGray">Estimate description</div>
          <CustomTextArea
            id="create-estimate-description"
            onChange={onEstimateDescriptionChange}
            placeholder="Add description"
            value={selectedEstimateDescription}
            name="estimate details"
            className="h-[100px] overflow-y-auto px-5 py-3 text-[17px] font-normal leading-5
            text-heading outline-none placeholder:text-[17px]"
            maxLength={1000}
            showRemainingChar={true}
          />
        </div> */}
      </div>
    </div>
  );
};

export default CreateEstimateDetails;
